export default __webpack_public_path__ + "static/media/Unmute Video.f4471a85.svg";